<template>
  <div class="container flex flex-direction">
    <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
    <div class="flex align-center justify-between top-box">
      <div class="flex-sub top-img-left"></div>
      <div class="top-name">{{ xiangmu_name }}物业数据管理屏</div>
      <div class="flex-sub top-img-right">
        <div class="time-box">
          {{ year }}年{{ month }}月
          <el-date-picker
            style="position: absolute;top: 0;left: 0;width: 100%;opacity: 0;cursor: pointer;"
            @change="setMonth"
            v-model="time"
            type="month"
            placeholder="选择月">
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="flex align-start justify-between padding">
      <div class="left-info">
        <div class="left-user">
          <h3 class="flex align-center justify-between">
            <span><img src="../../../assets/img/title-icon.png"> 社区概览</span>
            <img src="../../../assets/img/jiantou.png">
          </h3>
          <div class="user-img">
            <img :src="xiangmujinli_avatar" alt="">
          </div>
          <div class="manager-name">{{ xiangmujinli_name }}</div>
        </div>
        <div class="flex align-center justify-between flex-wrap margin-bottom-xs user-admin">
          <div><p>负责<br>小区</p><h4><b>{{ xiaoQuNum }}</b><span>个</span></h4></div>
          <div><p>管理<br>面积</p><h4><b>{{ zongMianJi }}</b><span>m²</span></h4></div>
          <div><p>房屋<br>认证</p><h4><b>{{ zongHuShu }}</b><span>户</span></h4></div>
          <div><p>登记<br>人口</p><h4><b>{{ zongRenKou }}</b><span>人</span></h4></div>
          <div><p>2022年<br>物业总收入</p><h4><b>{{ quanNianYingShou }}</b><span>元</span></h4></div>
          <div><p>2022年<br>物业总支出</p><h4><b>{{ quanNianYingFu }}</b><span>元</span></h4></div>
        </div>

        <div class="left-fenxi" v-if="two">
          <h3 class="flex align-center justify-between">
            <span><img src="../../../assets/img/title-icon.png"> 综合业务分析</span>
            <b>得分:{{ two.totle }}分</b>
          </h3>
          <div id="fenxi" style="width: 400px;height: 300px;margin: 0 auto;"></div>
        </div>

      </div>

      <div class="right-info" v-if="one">
        <div class="right-num flex align-center justify-between flex-wrap margin-bottom-sm">
          <div>业主签约率： <b>{{ one.yiQianHeTongLv }}%</b></div>
          <div>物业收缴率： <b>{{ one.yiJiaoFeiLv }}%</b></div>
          <div>总预算支出完成率： <b>{{ zongYuSuanZhiChuLv }}%</b></div>
          <div class="active">本月新增签约数： <b>{{ one.benYueXinZengHeTongShu }}户</b></div>
          <div class="active">缴费数户： <b>{{ one.yiJiaoFeiShu }}户</b></div>
          <div class="active">本月支出金额： <b>{{ benYueZhiChu }}元</b></div>
        </div>

        <div class="right-bar-box flex align-center justify-between">
          <div class="right-bar">
            <h3 class="flex align-center justify-between mode-title">
              <span><img src="../../../assets/img/title-icon.png"> 签约率</span>
            </h3>
            <div id="bar1" style="width: 580px;height: 270px;"></div>
            <div class="flex align-center justify-around sts-num" v-if="one">
              <div>平均签约率： <span>{{ one.yiQianHeTongLv }}%</span></div>
              <div class="active">平均缴费率： <span>{{ one.yiJiaoFeiLv }}%</span></div>
            </div>
          </div>
          <div class="right-bar">
            <h3 class="flex align-center justify-between mode-title">
              <span><img src="../../../assets/img/title-icon.png"> 报修/完成</span>
            </h3>
            <div id="bar2" style="width: 580px;height: 270px;"></div>
            <div class="flex align-center justify-around sts-num">
              <div>月度报修次数： <span>{{ YueBaoXiuNumZong }}</span></div>
              <div class="active">人均维修次数: <span>{{ XMPJbaoXiuNum }}</span></div>
            </div>
          </div>
        </div>

        <div class="right-other flex align-center justify-between">
          <div class="gj-list">
            <h3 class="flex align-center justify-between mode-title">
              <span><img src="../../../assets/img/title-icon.png"> 社区管家综合排名</span>
            </h3>
            <div class=" flex align-start justify-between">
              <div class="table-box active">
                <div>小区</div>
                <ul>
                  <li v-for="(item,index) in XQFenShuPaiMing" :key="index">
                    <i>{{ index + 1 }}</i>
                    <p class="active">{{ item.name }}</p></li>
                </ul>
              </div>
              <div class="table-box ">
                <div>管家</div>
                <ul>
                  <li v-for="(item,index) in YGFenShuPaiMing" :key="index"><p class="active">{{ item.name }}</p></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="bz-ts">
            <h3 class="flex align-center justify-between mode-title">
              <span><img src="../../../assets/img/title-icon.png"> 投诉/表扬</span>
            </h3>
            <div class=" flex align-start justify-between">
              <div class="table-box">
                <div><p class="active">小区</p>
                  <p>投诉</p></div>
                <ul>
                  <li v-for="(item,index) in XQbiaoYangCommentSort" :key="index"><p class="active">{{ item.name }}</p>
                    <p>{{ item.touSuNum }}</p></li>
                </ul>
              </div>
              <div class="table-box">
                <div><p class="active">小区</p>
                  <p>表扬</p></div>
                <ul>
                  <li v-for="(item,index) in XQbiaoYangCommentSort" :key="index"><p class="active">{{ item.name }}</p>
                    <p>{{ item.biaoYangNum }}</p></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {XMtongJiOne, XMtongJiTwo} from "@/api/tongji";
import {zhDate} from "@/utils/utils";
import {upFeil} from "@/config";
import * as echarts from "echarts";

export default {
  name: "community",
  data() {
    return {
      loading: false,
      time: new Date(),
      xiangmu_name: '',
      xiangmujinli_avatar: '',
      xiangmujinli_name: '',

      xiaoQuNum: 0,
      zongMianJi: 0,
      zongHuShu: 0,
      zongRenKou: 0,
      quanNianYingShou: 0,
      quanNianYingFu: 0,

      zongYuSuanZhiChuLv: 0,
      benYueZhiChu: 0,

      one: null,
      two: null,
      XMPJqianYueLv:0,
      XMPJshouFeiLv:0,

      BXdata: [],
      XQqianYueShouFeiLv: [],
      XQbiaoYangCommentSort: [],
      XQtouSuCommentSort: [],
      XQFenShuPaiMing: [],
      YGFenShuPaiMing: [],
      YueBaoXiuNumZong:0,
      XMPJbaoXiuNum:0,
    }
  },
  created() {
    this.year = zhDate(new Date(), 4)
    this.month = zhDate(new Date(), 5)
    this.init()
  },
  components: {},
  methods: {
    setMonth(e) {
      this.time = e
      this.year = zhDate(new Date(e), 4)
      this.month = zhDate(new Date(e), 5)
      this.init()
    },
    async init() {
      this.loading = true
      let _data = await XMtongJiOne(this.$route.query.id, this.year, this.month)
      let _data2 = await XMtongJiTwo(this.$route.query.id, this.year, this.month)
      this.loading = false
      //  社区概览
      this.xiangmu_name = _data.data.one.xiangmu_name
      this.xiangmujinli_name = _data.data.one.xiangmujinli_name
      this.xiangmujinli_avatar = upFeil + '/' + _data.data.one.xiangmujinli_avatar

      this.xiaoQuNum = _data.data.one.xiaoQuNum
      this.zongMianJi = _data.data.one.zongMianJi
      this.zongHuShu = _data.data.one.zongHuShu
      this.zongRenKou = _data.data.one.zongRenKou
      this.quanNianYingShou = _data.data.one.shiJiZongShouRu
      this.quanNianYingFu = _data.data.one.shiJiZongZhiChu
      // 综合业务分析
      this.two = _data2.data.two

      //  右侧顶部数据
      this.one = _data2.data.one
      this.zongYuSuanZhiChuLv = _data.data.zongYuSuanZhiChuLv
      this.benYueZhiChu = _data.data.benYueZhiChu

      //  签约率
      this.XQqianYueShouFeiLv = _data2.data.XQqianYueShouFeiLv

      //  报修/完成
      this.BXdata = _data.data.BXdata
       this.YueBaoXiuNumZong = _data.data.YueBaoXiuNumZong
       this.XMPJbaoXiuNum = _data.data.XMPJbaoXiuNum

      //  社区管家综合排名
      this.XQFenShuPaiMing = _data2.data.XQFenShuPaiMing
      this.YGFenShuPaiMing = _data2.data.YGFenShuPaiMing

      //  投诉/表扬
      this.XQtouSuCommentSort = _data.data.XQtouSuCommentSort
      this.XQbiaoYangCommentSort = _data.data.XQbiaoYangCommentSort

      this.$nextTick(() => {
        this.drawRadar()
        this.drawBar1()
        this.drawBar2()
      })
    },
    drawRadar() {
      let myChart = echarts.init(document.getElementById('fenxi'))
      // 绘制图表
      myChart.setOption({
        animationDuration: 3000,
        animationEasing: 'cubicOut',
        tooltip: {},
        radar: {
          // shape: 'circle',
          indicator: [
            {name: '收费率', max: 100},
            {name: '表彰', max: 100},
            {name: '投诉', max: 100},
            {name: '签约率', max: 100},

          ]
        },

        series: [
          {
            type: 'radar',
            data: [
              {
                value: [this.two.yiJiaoFeiLv, this.two.biaoYangNum, this.two.touSuNum, this.two.yiQianHeTongLv],
                name: '综合业务分析'
              },
            ],
            color: '#ffa563',
            label: {
              show: true,
              formatter: function (params) {
                return params.value;
              }
            },
            areaStyle: {
              color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                {
                  color: 'rgba(255, 145, 124, 0.1)',
                  offset: 0
                },
                {
                  color: 'rgba(255, 145, 124, 0.9)',
                  offset: 1
                }
              ])
            }
          }
        ]
      })
    },
    drawBar1() {
      let xData = []
      let y1Data = []
      let y2Data = []
      let y3Data = []
      let y4Data = []
      this.XQqianYueShouFeiLv.map(item => {
        xData.push(item.name)
        y1Data.push(item.XQyiQianHeTongLv)
        y2Data.push(item.XQyiJiaoFeiLv)
        y3Data.push(item.XQPJyiQianHeTongLv)
        y4Data.push(item.XQPJyiJiaoFeiLv)
      })
      let myChart = echarts.init(document.getElementById('bar1'))
      // 绘制图表
      myChart.setOption({
        animationDuration: 3000,
        animationEasing: 'cubicOut',
        tooltip: {
          trigger: 'axis'
        },
        //图例组件
        legend: {
          data: ['签约率', '缴费率', '平均签约率', '平均缴费率'],
          textStyle: {fontSize: 14, color: '#fff5b3'}
        },
        toolbox: {
          show: true,
        },
        // 设置网格样式
        grid: {
          show: false,// 显示边框
          top: '12%',
          left: '3%',
          right: '3%',
          bottom: '3%',
          borderColor: '#fff',// 边框颜色
          containLabel: true // 包含刻度文字在内
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            // prettier-ignore
            data: xData,
            axisTick: {
              show: false//去除刻度线
            },
            axisLabel: {
              color: '#fff',//文本颜色
              // rotate:40
            },
            axisLine: {
              show: false//去除轴线
            },
            // boundaryGap: false//去除轴内间距
          }
        ],
        yAxis: {
          // 数据作为刻度文字
          type: 'value',
          axisTick: {
            show: false//去除刻度线
          },
          axisLabel: {
            color: '#fff'//文本颜色
          },
          axisLine: {
            show: false//去除轴线
          },
          boundaryGap: false//去除轴内间距
        },
        series: [
          {
            name: '签约率',
            type: 'line',
            data: y1Data,
            color: '#b763ff'
          },
          {
            name: '缴费率',
            type: 'line',
            data: y2Data,
            color: '#60dfff'
          },
          {
            name: '平均签约率',
            type: 'line',
            data: y3Data,
            color: '#ffa563'
          },
          {
            name: '平均缴费率',
            type: 'line',
            data: y4Data,
            color: '#ff6969'
          }
        ]
      })

    },
    drawBar2() {
      let xData = []
      let y1Data = []
      let y2Data = []
      this.BXdata.map(item => {
        xData.push(item.name)
        y1Data.push(item.BaoXiuNum)
        y2Data.push(item.WanChengNum)
      })
      let myChart = echarts.init(document.getElementById('bar2'))
      // 绘制图表
      myChart.setOption({
        animationDuration: 3000,
        animationEasing: 'cubicOut',
        tooltip: {
          trigger: 'axis'
        },
        //图例组件
        legend: {
          data: ['报修', '完成'],
          textStyle: {fontSize: 14, color: '#fff5b3'}
        },
        toolbox: {
          show: true,
        },
        // 设置网格样式
        grid: {
          show: false,// 显示边框
          top: '12%',
          left: '3%',
          right: '3%',
          bottom: '3%',
          borderColor: '#fff',// 边框颜色
          containLabel: true // 包含刻度文字在内
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            // prettier-ignore
            data: xData,
            axisTick: {
              show: false//去除刻度线
            },
            axisLabel: {
              color: '#fff',//文本颜色
              // rotate:40
            },
            axisLine: {
              show: false//去除轴线
            },
            // boundaryGap: false//去除轴内间距
          }
        ],
        yAxis: {
          // 数据作为刻度文字
          type: 'value',
          axisTick: {
            show: false//去除刻度线
          },
          axisLabel: {
            color: '#fff'//文本颜色
          },
          axisLine: {
            show: false//去除轴线
          },
          boundaryGap: false//去除轴内间距
        },
        series: [
          {
            name: '报修',
            type: 'bar',
            data: y1Data,
            color: '#ffa563',
            barWidth: 20
          },
          {
            name: '完成',
            type: 'bar',
            data: y2Data,
            color: '#ff6969',
            barWidth: 20
          }
        ]
      })
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.container {
  background: url(../../../assets/img/bg_data.jpg) no-repeat top;
  background-size: 100% 100%;
  min-height: 100vh;
  min-width: 1900px;

  .loading {
    color: #ffffff;
    background: rgba(#000, .5);
    position: fixed;
    z-index: 99;
  }

  .top-box {
    height: 66px;

    .top-img-left {
      height: 66px;
      background: url("../../../assets/img/left-top.png") no-repeat top right;
    }

    .top-img-right {
      position: relative;
      height: 66px;
      background: url("../../../assets/img/right-top.png") no-repeat top left;

      .time-box {
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 24px;
        color: #ffdd99;
      }
    }

    .top-name {
      width: max-content;
      font-size: 40px;
      line-height: 66px;
      letter-spacing: 2px;
      padding: 0 30px;
      color: #ffffff;
      text-shadow: 0px 0px 7px rgba(52, 255, 204, 0.1);
      background: linear-gradient(-42deg,
        #ffd48a 0%,
        #fff5bb 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .mode-title {
    height: 50px;
    color: #fff;
    font-size: 26px;
  }

  .left-info {
    width: 520px;

    .left-user {
      h3 {
        height: 50px;
        color: #fff;
        font-size: 26px;
      }
    }

    .user-img {
      display: block;
      width: 166px;
      height: 215px;
      margin: 15px auto;
      background-color: #bc2a30;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: relative;
        top: 8px;
        left: -8px;
      }
    }
    .manager-name{
      text-align: center;
      font-size: 26px;
      line-height: 50px;
      letter-spacing: 1px;
      color: #ffffff;

    }

    .user-admin {
      div {
        width: 250px;
        height: 66px;
        padding: 20px;
        border: solid 1px #cf464a;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        p {
          font-size: 18px;
          letter-spacing: 1px;
          color: #f9b09f;
          margin-right: 20px;
        }

        h4 {
          line-height: 150%;

          b {
            font-size: 24px;
            letter-spacing: 1px;
            color: #fff5b3;
          }

          span {
            font-size: 18px;
            color: #f9b09f;
          }
        }
      }
    }

    .left-fenxi {
      height: 370px;
      padding: 20px;
      border: solid 1px #cf464a;

      h3 {
        font-size: 26px;
        color: #ffffff;
        height: 50px;
        line-height: 150%;
      }
    }
  }

  .right-info {
    width: 1300px;

    .right-num {
      height: 140px;
      padding: 20px;
      border: solid 1px #cf464a;
      margin-top: 20px;

      div {
        width: 33%;
        text-align: center;
        color: #ffa563;
        font-size: 30px;

        &.active {
          color: #ff6969;
        }

        b {
          color: #fff;

          span {
            font-size: 18px;
          }
        }
      }
    }

    .right-bar-box {
      margin-bottom: 30px;

      .right-bar {
        width: 640px;
        height: 405px;
        padding: 20px;
        border: solid 1px #cf464a;

        .sts-num {
          font-size: 20px;
          color: #ffa563;
          height: 50px;

          div {
            &.active {
              color: #ff6969;
            }

            span {
              color: #fff5b3;
            }
          }
        }
      }
    }

    .right-other {
      .gj-list {
        width: 640px;
        height: 370px;
        padding: 20px;
        border: solid 1px #cf464a;
        overflow-y: auto;

        .table-box {
          width: 200px;

          &.active {
            width: 360px;
            div{
              padding-left: 50px;
            }

            li {
              position: relative;

              i {
                position: absolute;
                top: 15px;
                left: 15px;
                width: 20px;
                height: 20px;
                border-radius: 20px;
                text-align: center;
                line-height: 20px;
                font-size: 16px;
                color: #fff;
              }

              p {
                padding-left: 50px;
              }
              &:first-child{
                i{
                  background-color: #ff9743;
                }
              }
              &:nth-child(2){
                i{
                  background-color: #ad65ea;
                }
              }
              &:nth-child(3){
                i{
                  background-color: #3dbfe5;
                }
              }
            }

          }

          div {
            width: 100%;
            height: 50px;
            line-height: 50px;
            background-color: #a7292e;
            text-align: center;
            font-size: 18px;
            color: #ffffff;
            padding: 0 10px;
          }

          ul {
            height: 228px;
            overflow-y: auto;

            li {
              background: #bc3235;
              min-height: 48px;
              border-bottom: 1px solid #e92f2f;

              p {
                text-align: center;
                font-size: 16px;
                color: #ffffff;
                padding: 5px;
                line-height: 40px;
              }
            }
          }

        }
      }

      .bz-ts {
        width: 640px;
        height: 370px;
        padding: 20px;
        border: solid 1px #cf464a;

        .table-box {
          width: 290px;

          div {
            display: flex;
            align-items: center;
            height: 50px;
            background-color: #a7292e;

            p {
              text-align: center;
              font-size: 18px;
              color: #ffffff;
              padding: 0 10px;
              width: 40%;
              line-height: 150%;

              &.active {
                width: 60%;
              }
            }
          }

          ul {
            height: 228px;
            overflow-y: auto;

            li {
              display: flex;
              align-items: center;
              background: #bc3235;
              min-height: 48px;
              border-bottom: 1px solid #e92f2f;

              p {
                text-align: center;
                font-size: 16px;
                color: #ffffff;
                padding: 5px;
                width: 40%;

                &.active {
                  width: 60%;
                }
              }
            }
          }

        }
      }
    }
  }
}
</style>
